export default __webpack_public_path__ + "static/media/orderDetailsArrow.a2fd6f50.svg";